import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthWrapper';
import LogoLoader from './LogoLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  
  // const [hold, setHold] = React.useState(true);
  // React.useEffect(() => {
  //   const timer = setTimeout(() => setHold(false), 1200);
  //   return () => clearTimeout(timer);
  // }, []);

  // Show loading state while checking authentication
  if (isLoading /* || hold */) {
    return <LogoLoader />;
  }

  const publicPaths = ['/', '/landing', '/supply-gpu', '/help', '/models'];
  const isPublicRoute = publicPaths.some(path =>
    location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  // Redirect to landing if not authenticated, unless route is public
  if (!isAuthenticated && !isPublicRoute) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
